import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <span className="inline-flex h-5 items-center gap-1 rounded-md bg-brand-500 px-1.5 text-[9px] font-bold uppercase tracking-[0.16em] text-white">
        404
      </span>
      <h1 className="text-balance text-[48px] font-semibold leading-[1.05] tracking-[-0.02em] text-ink-950 sm:text-[56px]">
        Página não encontrada
      </h1>
      <p className="max-w-md text-sm text-ink-500">
        A página que você procura não existe ou foi movida.
      </p>
      <Button onClick={() => navigate("/")}>Voltar para o início</Button>
    </div>
  );
}
